import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function AdminStudents() {
  const [list, setList] = useState([]);
  const [enrolls, setEnrolls] = useState([]);
  useEffect(() => {
    api.get("/api/admin/students").then(({data}) => setList(data));
    api.get("/api/admin/enrollments").then(({data}) => setEnrolls(data));
  }, []);

  return (
    <div data-testid="admin-students">
      <div className="label-eyebrow">Students</div>
      <h1 className="font-display font-black text-3xl mt-1">All students</h1>

      <div className="mt-6 bg-white border border-[#E5E7EB] rounded-xl overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-[#F3F4F6]">
            <tr><th className="px-4 py-3 text-left">Name</th><th className="px-4 py-3 text-left">Email</th><th className="px-4 py-3 text-left">Enrollments</th><th className="px-4 py-3 text-left">Joined</th></tr>
          </thead>
          <tbody>
            {list.map((s) => (
              <tr key={s.id} className="border-t border-[#E5E7EB]">
                <td className="px-4 py-3 font-semibold">{s.full_name}</td>
                <td className="px-4 py-3">{s.email}</td>
                <td className="px-4 py-3">{s.enrollment_count}</td>
                <td className="px-4 py-3 text-[#4B5563]">{s.created_at?.slice(0,10)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <h2 className="font-display font-bold text-xl mt-12">Recent enrollments</h2>
      <div className="mt-3 bg-white border border-[#E5E7EB] rounded-xl overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-[#F3F4F6]">
            <tr><th className="px-4 py-3 text-left">Student</th><th className="px-4 py-3 text-left">Course</th><th className="px-4 py-3 text-left">Progress</th><th className="px-4 py-3 text-left">Status</th><th className="px-4 py-3 text-left">Date</th></tr>
          </thead>
          <tbody>
            {enrolls.map((e) => (
              <tr key={e.id} className="border-t border-[#E5E7EB]">
                <td className="px-4 py-3"><div className="font-semibold">{e.user_name}</div><div className="text-xs text-[#4B5563]">{e.user_email}</div></td>
                <td className="px-4 py-3">{e.course_title}</td>
                <td className="px-4 py-3">{e.completion_percent}%</td>
                <td className="px-4 py-3">
                  <span className={`text-xs font-bold uppercase px-2 py-1 rounded ${e.completed ? "bg-[#064E3B]/10 text-[#064E3B]" : "bg-[#F3F4F6] text-[#4B5563]"}`}>{e.completed ? "Completed" : "In progress"}</span>
                </td>
                <td className="px-4 py-3 text-[#4B5563]">{e.enrolled_at?.slice(0,10)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
